import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'

import {
  SelectField,
  InputField,
  CheckboxGroup,
  StateSelect,
} from '../../components/inputs'
import { TaskFilterCheckboxes } from './taskFilterCheckboxes'
import {
  normalizeEndDate,
  normalizeStartDate,
} from '../../helpers/filterHelper'
import LoaderButton from '../../components/loaderButton'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

import { User } from '../../core/types'
import { ReduxFormProps } from '../../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  adminUsers: User[]
  blur?: Callback
  cancel: Callback
  change?: Callback
  clear?: Callback
  clearFields?: Callback
  currentUserBadges: string[]
  existingFormValues: object[]
}

export class TaskFilterForm extends Component<ReduxFormProps<Props, object>> {
  static displayName = 'TaskFilterForm'

  render() {
    const {
      handleSubmit,
      submitting,
      adminUsers,
      clear,
      cancel,
      currentUserBadges,
      blur,
      change,
      existingFormValues,
    } = this.props

    const adminOptions = adminUsers.map((admin) => (
      <option value={admin.id} key={admin.id}>
        {admin.name}
      </option>
    ))

    const statusOptions = [
      { label: 'Approved', value: 'APPROVED' },
      { label: 'Completed', value: 'COMPLETED' },
      { label: 'Pending', value: 'PENDING' },
    ]

    return (
      <form
        className="form index-filter__form"
        name="TaskFilterForm"
        onSubmit={handleSubmit}
      >
        <div className="task-filter">
          <div className="task-filter__row">
            <div>
              <h2 className="filter__header">Category</h2>
              <hr className="form__hr filter__hr" />
              <Field<any> // TODO-TS
                label="Select a category"
                name="entityType"
                component={SelectField}
                aria-required="true"
                gridClass="filter__field"
              >
                <option value="">No category selected</option>
                <option value="LISTING">Listings</option>
                <option value="LOAN">Loans</option>
                <option value="OFFER">Offers</option>
                <option value="REFI">Refis</option>
                <option value="USER">Users</option>
              </Field>
            </div>

            <div>
              <h2 className="filter__header">Assignee</h2>
              <hr className="form__hr filter__hr" />
              <Field<any> // TODO-TS
                label="Select an assignee"
                name="assigneeId"
                component={SelectField}
                aria-required="true"
                gridClass="field filter__field"
              >
                <option value="">No assignee selected</option>
                {adminOptions}
              </Field>
            </div>
          </div>

          <div className="task-filter__row">
            <div>
              <h2 className="filter__header">State</h2>
              <hr className="form__hr filter__hr" />

              <StateSelect
                defaultOption="No state selected"
                label="Select a state"
                name="userActivationState"
              />
            </div>

            <div>
              <h2 className="filter__header">Date range</h2>
              <hr className="form__hr filter__hr" />
              <div className="filter__date-fields">
                <Field<any> // TODO-TS
                  type="text"
                  label="From"
                  name="pendingAtAfter"
                  format={(value) => (value === '' ? null : value)}
                  component={InputField}
                  placeholder="mm/dd/yyyy"
                  mask={[
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  pipe={autoCorrectedDatePipe}
                  normalize={normalizeStartDate}
                  keepCharPositions={true}
                  gridClass="filter__field"
                />

                <Field<any> // TODO-TS
                  type="text"
                  label="To"
                  name="pendingAtBefore"
                  format={(value) =>
                    value === '' || value === 0 ? null : value
                  }
                  component={InputField}
                  placeholder="mm/dd/yyyy"
                  mask={[
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  pipe={autoCorrectedDatePipe}
                  normalize={normalizeEndDate}
                  keepCharPositions={true}
                  gridClass="filter__field"
                />
              </div>
            </div>

            <div>
              <h2 className="filter__header">Status</h2>
              <hr className="form__hr filter__hr" />
              <CheckboxGroup
                name="status"
                gridRow
                options={statusOptions}
                aria-required="true"
                gridClass="filter__status-field filter__field"
              />
            </div>
          </div>

          <TaskFilterCheckboxes
            currentUserBadges={currentUserBadges}
            blur={blur}
            change={change}
            existingFormValues={existingFormValues}
          />

          <div className="task-filter__row">
            <div className="form__group filter__buttons">
              <LoaderButton
                type="submit"
                className="button button--primary-round filter__button--apply"
                isLoading={submitting}
              >
                Apply
              </LoaderButton>
              <a
                onClick={clear}
                className="button button--secondary-round filter__button--reset"
                aria-label="Clear"
              >
                Clear
              </a>
            </div>
            <a
              onClick={cancel}
              className="button button-link-text filter__cancel"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    )
  }
}

const FilterForm = reduxForm<object, Props>({
  form: 'taskFilterForm',
  enableReinitialize: false,
  destroyOnUnmount: true,
})(TaskFilterForm)

const selector = formValueSelector('taskFilterForm')

const ConnectedTaskFilterForm = connect((state) => ({
  existingFormValues: selector(state, 'taskType'),
}))(FilterForm)

export default ConnectedTaskFilterForm
